import axios from "axios";

const editPanel = document.getElementById('answer-edit-panel');
const closeButton = document.getElementById('edit-panel-close-button');

const genderSelect = document.getElementById('gender-edit-form');
const ageSelect = document.getElementById('age-edit-form');
const relationSelect = document.getElementById('relation-edit-form');
const customRelationInput = document.getElementById('custom-relation-input');
const qnaContainers = Array.from(document.querySelectorAll('.qna-container'));
const answerTexts = Array.from(document.querySelectorAll('.edit-panel-answer-text'));
const categoryContainers = Array.from(document.querySelectorAll('.answer-categories'));
const questionTextEls = [
  document.getElementById('edit-panel-question-1-text'),
  document.getElementById('edit-panel-question-2-text'),
  document.getElementById('edit-panel-question-3-text')
];

const editPanelSource = document.getElementById('edit-panel-source');
const editPanelDate = document.getElementById('edit-panel-date');
const additionalContainer = document.getElementById('edit-panel-additional-container');
const additionalText = document.getElementById('edit-panel-additional-text');

const imageContainer = document.getElementById('edit-panel-image-container');
const image = document.getElementById('edit-panel-image');

const verifyButtton = document.getElementById('edit-panel-verify-button');
const saveButton = document.getElementById('edit-panel-save-button');

const qnaRow = document.getElementById('qna-row');
const adminActionsContainer = document.getElementById('admin-actions-container');
const categoriesEditContainer = document.getElementById('categories-edit-container');

const ALL_CATEGORIES = [
  "other", "safety", "comfort", "housing", "experience",
  "identity", "leisure", "activities", "fun", "accessibility",
  "mobility", "infrastructure", "nature", "aesthetics", "biodiversity",
  "economy", "heritage", "tourism", "climate", "privacy"
];

const API_URL = 'https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPHP';

const fallbackLocations = {
  1: {
    title: 'Plek van Havenloods',
    questions: ['Sfeer', 'Havenloods', 'Deze plek is bedoelt voor...']
  },
  2: {
    title: 'Eemskanaal',
    questions: ['Sfeer', 'De kade is bedoelt voor...', 'Het water is bedoelt voor..']
  },
  3: {
    title: 'Deense Haven',
    questions: ['Sfeer', 'De kade is bedoelt voor...', 'Het water is bedoelt voor..']
  }
};

function normalizeLocationId(value) {
  const direct = Number(value);
  if (Number.isFinite(direct) && direct > 0) return direct;
  const extracted = parseInt(String(value || '').replace(/\D+/g, ''), 10);
  return Number.isFinite(extracted) && extracted > 0 ? extracted : 0;
}

function getLocationMeta(questionId) {
  const locId = normalizeLocationId(questionId);
  const points = Array.isArray(window.participationPoints) ? window.participationPoints : [];
  const point = points.find(p => Number(p.no) === locId);
  if (point) {
    return {
      title: point.title || point.name || fallbackLocations[locId]?.title || 'Locatie',
      questions: [
        point.Question1?.name,
        point.Question2?.name,
        point.Question3?.name
      ]
    };
  }
  return fallbackLocations[locId] || { title: 'Locatie', questions: [] };
}

function parseAnswerField(value) {
  if (value == null) return [];
  if (Array.isArray(value)) {
    return value.map(String).filter(v => v.trim() !== '' && v !== '-');
  }

  const raw = String(value).trim();
  if (!raw || raw === '-') return [];

  if (raw.startsWith('[') && raw.endsWith(']')) {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.map(String).filter(v => v.trim() !== '' && v !== '-');
      }
      if (parsed != null) return [String(parsed)];
    } catch (_err) {
      // fall through
    }
  }

  let cleaned = raw;
  if (cleaned.startsWith('[') && cleaned.endsWith(']')) {
    cleaned = cleaned.slice(1, -1);
  }
  cleaned = cleaned.trim();
  if (!cleaned) return [];

  if (cleaned.includes(',')) {
    return cleaned
      .split(',')
      .map(part => part.trim().replace(/^\"+|\"+$/g, '').replace(/^'+|'+$/g, ''))
      .filter(part => part !== '' && part !== '-');
  }

  const single = cleaned.replace(/^\"+|\"+$/g, '').replace(/^'+|'+$/g, '').trim();
  return single ? [single] : [];
}

function formatAnswerField(value) {
  const list = parseAnswerField(value);
  if (!list.length) return '-';
  return list.join(', ');
}

function pickFirstValue(item, keys, fallback = '-') {
  for (const key of keys) {
    const value = item?.[key];
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      return value;
    }
  }
  return fallback;
}

/**
 * Update an answer on the server
 * @param {*} answerId - The ID of the answer to update
 * @param {*} data - The data to update the answer with, an object with one or two properties:
 *                     - edited_text: The new answer text
 *                     - answer_verified: The new verification status (0 or 1)
 */
function updateAnswer(answerId, data) {
  axios.post(`${API_URL}/Update_Answer.php?id=${answerId}`, data)
    .then(response => {
      console.log(response.data);
      refreshFunction?.();
    })
    .catch(error => {
      console.error('Error fetching answers from server:', error);
    });
}

let currentAnswers = [];
let isImageMode = false;

function isImageEntry(entry) {
  return !!entry && Object.prototype.hasOwnProperty.call(entry, 'question1_answers');
}

/**
 * Funciton run when updating the entry list is necessary
 */
let refreshFunction;

verifyButtton.addEventListener('click', () => {
  if (isImageMode) return;
  currentAnswers.forEach((answer, i) => {
    if (currentAnswers[i].answer_verified === "1") return;

    updateAnswer(answer.id, { answer_verified: 1 });
  });
});

/**
 * The original data of the currently edited answers, used to check for changes
 */
let originalData = null;

/**
 * Returns the data currently in the edit forms regarding a specific question
 */
function getDataFromForms(questionId) {
  return {
    text: answerTexts[questionId].value,
    gender: genderSelect.value,
    age_group: ageSelect.value,
    relation: relationSelect.value.startsWith('anders') ?
      `${relationSelect.value} ${customRelationInput.value}` : relationSelect.value,
    categories: Array.from(
      categoryContainers[questionId].querySelectorAll('.category')
    ).map(catDiv => catDiv.textContent.trim()).sort().join(', ')
  };
}

saveButton.addEventListener('click', () => {
  if (isImageMode) return;
  currentAnswers.forEach((answer, i) => {
    const formData = getDataFromForms(i);

    updateAnswer(answer.id, {
      edited_text: formData.text,
      edited_gender: formData.gender,
      edited_age_group: formData.age_group,
      edited_relation_to_place: formData.relation,
      edited_categories: formData.categories
    });
  });
});

closeButton.addEventListener('click', () => {
  editPanel.classList.add('hidden');
});

function removePrefix(str, prefix) {
  if (str.startsWith(prefix)) {
    return str.slice(prefix.length);
  }
  return str;
}

genderSelect.addEventListener('change', checkForChanges);
ageSelect.addEventListener('change', checkForChanges);
relationSelect.addEventListener('change', () => {
  if (relationSelect.value === 'anders, namelijk:') {
    customRelationInput.classList.remove('hidden');
  } else {
    customRelationInput.classList.add('hidden');
  }

  checkForChanges();
});

customRelationInput.addEventListener('change', checkForChanges);
customRelationInput.addEventListener('keyup', checkForChanges);

const questions = [
  "Wat zou jij straks willen doen in Havenpark? Noem drie dingen.",
  "Hoe kan Havenpark een fijne plek worden voor Groningers?",
  "Wat ik alvast wil meegeven is, ...",
];

/**
 * Adjust the edit panel to display data relevent to the provided answers
 * @param {*} answers - An array of the three answer objects which originate from the same form,
 * or a 1-element array with an answer submitted through the app
 * @param {*} refreshFn - A funciton run when updating the entry list is necessary
 */
export default function openEditPanel(answers = [], refreshFn) {
  currentAnswers = answers.toSorted((a, b) => parseInt(a.question_id) - parseInt(b.question_id));
  const data = currentAnswers[0] || {};
  isImageMode = isImageEntry(data);

  console.log('opening edit panel. answers: ', currentAnswers);

  refreshFunction = refreshFn;
  customRelationInput.classList.add('hidden');
  imageContainer.classList.add('hidden');
  additionalContainer?.classList.add('hidden');
  editPanel.classList.remove('hidden');
  qnaRow.classList.remove('verified');
  verifyButtton.classList.remove('hidden');
  adminActionsContainer.classList.remove('hidden');
  categoriesEditContainer.classList.remove('hidden');

  editPanelSource.textContent = data.source === 'form' ? 'formulier' : 'app';
  editPanelDate.textContent = data.created || '-';

  if (isImageMode) {
    const userLabel = data.user_identifier && data.user_identifier !== '-'
      ? data.user_identifier
      : (data.user_IP && data.user_IP !== '-' ? data.user_IP : '-');
    editPanelSource.textContent = userLabel;

    const imageUrl = data.generated_image && data.generated_image !== '-' ? data.generated_image : data.original_image;
    if (imageUrl && imageUrl !== '-') {
      imageContainer.classList.remove('hidden');
      image.src = imageUrl;
    }

    verifyButtton.classList.add('hidden');
    adminActionsContainer.classList.add('hidden');
    categoriesEditContainer.classList.add('hidden');

    genderSelect.disabled = true;
    ageSelect.disabled = true;
    relationSelect.disabled = true;
    customRelationInput.disabled = true;

    const ageValue = pickFirstValue(data, ['age_group', 'ageGroup', 'age'], '-');
    const genderValue = pickFirstValue(data, ['gender', 'genderGroup'], '-');
    const relationValue = pickFirstValue(data, ['relation_to_place', 'relationToPlace', 'relation'], '-');

    genderSelect.value = genderValue;
    ageSelect.value = ageValue;
    relationSelect.value = relationValue;
    if (relationSelect.value === '') {
      const relationToPlace = relationValue ?? '-';

      relationSelect.value = "anders, namelijk:";
      if (relationToPlace.startsWith('anders:'))
        customRelationInput.value = removePrefix(relationToPlace, 'anders:').trim();
      else if (relationToPlace.startsWith('anders, namelijk:')) {
        customRelationInput.value = removePrefix(relationToPlace, 'anders, namelijk:').trim();
      }
      else customRelationInput.value = relationToPlace;

      customRelationInput.classList.remove('hidden');
    }

    const locationMeta = getLocationMeta(data.question_id);
    const questionLabels = locationMeta.questions?.length
      ? locationMeta.questions
      : ['Vraag 1', 'Vraag 2', 'Vraag 3'];

    qnaContainers.forEach((con, i) => {
      con.classList.remove('hidden');
      con.querySelectorAll('.text-div').forEach(div => div.remove());
      answerTexts[i].classList.add('hidden');

      if (questionTextEls[i]) {
        questionTextEls[i].innerText = questionLabels[i] || `Vraag ${i + 1}`;
      }

      const answerValue = [
        data.question1_answers,
        data.question2_answers,
        data.question3_answers
      ][i];

      const textDiv = document.createElement('div');
      textDiv.innerText = formatAnswerField(answerValue);
      textDiv.classList.add('text-div');
      con.appendChild(textDiv);
    });

    if (additionalContainer && additionalText) {
      const extra = String(data.additional_text ?? '').trim();
      if (extra && extra !== '-') {
        additionalText.textContent = extra;
        additionalContainer.classList.remove('hidden');
      } else {
        additionalContainer.classList.add('hidden');
      }
    }

    categoryContainers.forEach(con => con.classList.add('hidden'));
    originalData = [];
    saveButton.disabled = true;
    return;
  }

  if (data.source === 'form') {
    imageContainer.classList.remove('hidden');
    image.src = data.scan_image;
  }

  if (currentAnswers.every(answer => answer.answer_verified === "1")) {
    qnaRow.classList.add("verified");
    verifyButtton.classList.add("hidden");
  }

  const isEditable = data.source === 'form';

  if (!isEditable) {
    // Hide verified features for app answers
    qnaRow.classList.remove('verified');
    verifyButtton.classList.add("hidden");

    // Hide save button for app answers
    adminActionsContainer.classList.add('hidden');
  }

  genderSelect.disabled = !isEditable;
  ageSelect.disabled = !isEditable;
  relationSelect.disabled = !isEditable;
  customRelationInput.disabled = !isEditable;

  genderSelect.value = data.edited_gender ?? data.gender;
  ageSelect.value = data.edited_age_group ?? data.age_group;
  relationSelect.value = data.edited_relation_to_place ?? data.relation_to_place;
  if (relationSelect.value === '') {
    // relation_to_place is not an accepted value, show custom input
    const relationToPlace = data.edited_relation_to_place ?? data.relation_to_place;

    relationSelect.value = "anders, namelijk:";
    if (relationToPlace.startsWith('anders:'))
      customRelationInput.value = removePrefix(relationToPlace, 'anders:').trim();
    else if (relationToPlace.startsWith('anders, namelijk:')) {
      customRelationInput.value = removePrefix(relationToPlace, 'anders, namelijk:').trim();
    }
    else customRelationInput.value = relationToPlace;

    customRelationInput.classList.remove('hidden');
  }

  qnaContainers.forEach(con => con.classList.add('hidden'));
  categoryContainers.forEach(con => con.classList.add('hidden'));
  if (currentAnswers.length === 1) {
    // Hide category spans
    const spans = categoriesEditContainer.querySelectorAll('span.category-label');

    spans.forEach(span => span.classList.add('hidden'));

    // Set question number
    const select = document.querySelector('.question-edit-form.q1');
    const text = document.getElementById('edit-panel-question-1-text');

    select.value = data.question_id;
    text.innerText = questions[parseInt(data.question_id) - 1];
  } else if (currentAnswers.length === 3) {
    // Show category spans
    const spans = categoriesEditContainer.querySelectorAll('span.category-label');

    spans.forEach(span => span.classList.remove('hidden'));

    // Reset question number
    const select = document.querySelector('.question-edit-form.q1');
    const text = document.getElementById('edit-panel-question-1-text');

    select.value = "1";
    text.innerText = questions[0];
  }

  originalData = [];
  currentAnswers.forEach((answer, i) => {
    const text = answer.edited_text ?? answer.answer_text;

    // Clear existing answer text divs
    qnaContainers[i].querySelectorAll('.text-div').forEach(div => div.remove());

    if (!isEditable) {
      answerTexts[i].classList.add('hidden');
      const textDiv = document.createElement('div');

      textDiv.innerText = text;
      textDiv.classList.add('text-div');
      qnaContainers[i].appendChild(textDiv);
    } else {
      answerTexts[i].value = text;
      answerTexts[i].classList.remove('hidden');
    }

    qnaContainers[i].classList.remove('hidden');
    categoryContainers[i].classList.remove('hidden');
    categoryContainers[i].innerHTML = '';

    const sourceCategories = answer.edited_categories ?? answer.categories;
    const categories = sourceCategories.split(',').map(s => s.trim()).filter(s => s.length > 0);

    console.log('categories for answer ', i, ': ', categories);
    for (const category of categories) {
      categoryContainers[i].appendChild(createCategoryDiv(i, category, isEditable));
    }

    if (isEditable) {
      const categorySelect = createCategorySelect(i, categories);

      categoryContainers[i].appendChild(categorySelect);
    }

    originalData[i] = getDataFromForms(i);
  });

  checkForChanges();
}

function createCategoryDiv(answerIndex, categoryName, isRemovable = true) {
  const categoryDiv = document.createElement('div');

  categoryDiv.classList.add('category');
  categoryDiv.textContent = categoryName;

  if (!isRemovable) return categoryDiv;

  const removeButton = document.createElement('button');
  const removeIcon = document.createElement('img');

  removeButton.classList.add('UrbanFutureReactionsClose', 'UrbanFutureReactions');
  removeIcon.src = 'https://publictwin.info/digital_maquette/content/Urban_Future/Icons/CloseIcon.svg';
  removeButton.appendChild(removeIcon);

  removeButton.addEventListener('click', () => {
    const categoryContainer = categoryContainers[answerIndex];
    const categorySelect = categoryContainer.querySelector('.category-select');

    categoryContainer.removeChild(categoryDiv);

    // Add removed category back to the select options
    const option = document.createElement('option');

    option.value = categoryName;
    option.textContent = categoryName;
    categorySelect.appendChild(option);
    // Unhide the select if it was hidden
    if (categorySelect.classList.contains('hidden')) {
      categorySelect.classList.remove('hidden');
    }
    checkForChanges();
  });

  categoryDiv.appendChild(removeButton);

  return categoryDiv;
}

function createCategorySelect(answerIndex, existingCategories) {
  const template = document.createElement('template');

  let html = `
    <select class="UrbanFutureSelect category-select" data-answer-index="${answerIndex}">
      <option value="" disabled="" selected="" hidden="">+ nieuw</option>`;

  for (const category of ALL_CATEGORIES) {
    if (existingCategories.includes(category)) continue;
    html += `<option value="${category}">${category}</option>`;
  }
  html += `</select>`;

  template.innerHTML = html.trim();

  const selectElement = template.content.firstChild;

  selectElement.addEventListener('change', (event) => {
    const select = event.target;
    const selectedCategory = select.value;
    const answerIdx = parseInt(select.dataset.answerIndex);
    const categoryDiv = createCategoryDiv(answerIdx, selectedCategory);

    categoryContainers[answerIdx].insertBefore(
      categoryDiv,
      categoryContainers[answerIdx].querySelector('.category-select')
    );

    // Remove added category from the select options
    const optionToRemove = select.querySelector(`option[value="${selectedCategory}"]`);

    optionToRemove?.remove();

    // Hide the select if all categories have been added
    if (select.options.length === 1) {
      select.classList.add('hidden');
    }

    // Reset the select element
    select.value = '';

    checkForChanges();
  });

  return selectElement;
}

/**
 * Check if changes have been made to the currently edited answers
 */
function checkForChanges() {
  let changesWereMade = false;

  originalData.forEach((originalAnswer, i) => {
    const currentAnswer = getDataFromForms(i);

    if (JSON.stringify(originalAnswer) !== JSON.stringify(currentAnswer)) {
      changesWereMade = true;
    }
  });

  if (changesWereMade) {
    saveButton.disabled = false;
  } else {
    saveButton.disabled = true;
  }
}

answerTexts.forEach(answerText => {
  answerText.addEventListener('change', checkForChanges);
  answerText.addEventListener('keyup', checkForChanges);
});

/**
 * Function run when the currently open panel should be updated
 */
export function refreshEditPanel(changedAnswers) {
  console.log('refreshing edit panel');

  const currentAnswersIds = currentAnswers.map(a => a.id);
  let refreshNeeded = false;

  for (const answer of changedAnswers) {
    if (currentAnswersIds.includes(answer.id)) {
      refreshNeeded = true;
      break;
    }
  }

  if (!refreshNeeded) return;

  openEditPanel(changedAnswers, refreshFunction);
}
